export default __webpack_public_path__ + "static/media/about3.f192148d.jpg";